import { useTranslation } from '@frontend/i18n';
import { Page } from '@frontend/page';
import { ScheduleRequestsHistoryTable } from '../../components/ScheduleRequestsHistoryTable';

const CALENDAR_ROUTE = '/schedule/calendar';

export const ScheduleRequestsHistory = () => {
  const { t } = useTranslation('schedule-request-history');
  return (
    <Page>
      <Page.Header>
        <Page.Header.Breadcrumbs
          breadcrumbs={[
            {
              label: t('Calendar'),
              to: CALENDAR_ROUTE,
            },
            {
              label: t('Schedule Request History'),
            },
          ]}
        />
        <Page.Header.Heading>
          <Page.Header.Title title={t('Schedule Request History')} />
          <Page.Header.Subtitle subtitle={t("A summary of the practice's history for online scheduling requests.")} />
        </Page.Header.Heading>
      </Page.Header>
      <Page.Body>
        <ScheduleRequestsHistoryTable />
      </Page.Body>
    </Page>
  );
};
